import click from './click';

export function saveCanvasAsPng(canvas: HTMLCanvasElement, fileName: string) {
	canvas.toBlob(blob => {
		saveBlobAs(blob!, fileName);
	}, 'image/png');
}

export function saveBlobAs(data: Blob, fileName: string) {

	const link = document.createElement('a');

	if (typeof link.download === 'string') {

		// Si acepta el atributo download lo hacemos con createObjectUrl para que sea más
		// eficiente

		link.target = '_blank';
		link.href = URL.createObjectURL(data);
		link.download = fileName;
		click(link);

		setTimeout(function () { URL.revokeObjectURL(link.href); }, 5000);
	} else {
		const reader = new FileReader();

		reader.onloadend = () => {

			const uri = '' + reader.result;
			// Safari no soporta el atributo download, a partir del 10.1 Desktop y 10.3 en iOS sí lo hace.
			// No hay manera de indicarle el nombre del fichero. Si lo reconoce lo abre
			// en el browser, si no el usuario prodrá adjuntar o enviarse el archivo
			// renombrarlo a .zip o lo que toque para abrirlo y verlo.
			// Hay una librería FileSaver.js que hace algo similar a esto. Lo único distinto
			// es que el mime type lo cambia a attachment.
			// https://github.com/eligrey/FileSaver.js/
			// OJO: Esto es menos eficiente que createObjectUrl y seguramente tenga un limite el href
			if (!window.open(uri))
				window.location.href = uri;
		};
		reader.readAsDataURL(data);
	}
}
